import React from 'react';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import GridOcorrencias from '~/Components/Ocorrencias/GridOcorrencias';
import moment from 'moment';

/**
 * Grid de Títulos com coluna Sel e botão Imprimir.
 * Modo agregado: Titulo, Quantidade, Sel.
 * Modo detalhe: Titulo, Data, Usuário, Conta, Apelido, Sel.
 */
const GridTitulos = ({
  dados,
  total,
  pagina,
  titulosSel,
  onSelToggle,
  onMarcarTodos,
  onDesmarcarTodos,
  onLinhaClick,
  onImprimir,
  detalhar,
  onPaginaChange,
}) => {
  const colunasAgregado = [
    { key: 'titulo', label: 'Título' },
    { key: 'quantidade', label: 'Qtd', width: 60 },
  ];

  const colunasDetalhe = [
    { key: 'titulo', label: 'Título' },
    {
      key: 'data_ocorrencia',
      label: 'Data',
      width: 100,
      render: (item) => item.data_ocorrencia ? moment(item.data_ocorrencia).format('DD/MM/YYYY') : '',
    },
    { key: 'nome_usuario', label: 'Usuário' },
    { key: 'codigo_conta', label: 'Cód. Conta', width: 80 },
    { key: 'apelido_conta', label: 'Conta' },
  ];

  const handleImprimir = () => {
    const marcados = Object.keys(titulosSel || {}).filter((k) => titulosSel[k]);
    if (marcados.length === 0 && (dados || []).length === 0) {
      toast.warn('Favor selecionar um Título');
      return;
    }
    onImprimir(marcados);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <strong style={{ fontSize: 13 }}>Ocorrências</strong>
        <Button size="sm" variant="outline-primary" onClick={handleImprimir}>
          Imprimir
        </Button>
      </div>
      <GridOcorrencias
        dados={dados}
        total={total}
        pagina={pagina}
        colunas={detalhar ? colunasDetalhe : colunasAgregado}
        comSel
        titulosSel={titulosSel}
        onSelToggle={onSelToggle}
        onMarcarTodos={onMarcarTodos}
        onDesmarcarTodos={onDesmarcarTodos}
        onLinhaClick={onLinhaClick}
        linhaSelecionada={null}
        chaveSelecao="titulo"
        onPaginaChange={onPaginaChange}
      />
    </div>
  );
};

export default GridTitulos;
